<script setup>
import { appConfig } from '@/lib/appConfig';
import { errorHandler } from '@/lib/errorHandler';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const router = useRouter();
const { fullPath, query } = useRoute();
const { commit } = useStore();

enterByProvider();

async function enterByProvider() {
  if (!query?.code?.length) router.replace('/');
  const url = new URL(fullPath, appConfig.domain);
  try {
    const response = await fetch(url);

    if (response.ok) {
      const { token } = await response.json();
      localStorage.setItem('token', token);
      commit('setToken', token);
      setTimeout(() => router.replace('/main/dashboard'));
      return
    }

    if (response.status === 401) {
      errorHandler(response)
    }
    router.replace('/')
  } catch(err) {
    console.log(err)
    router.replace('/')
  }
}
</script>

<template>
  <Teleport to="body">
    <div class="loader">
      <img src="@/assets/img/iri-white.svg" alt="ИРИ" class="loader__img">
    </div>
  </Teleport>
</template>

<style scoped>
.loader {
  display: flex;
  position: fixed;
  inset: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
  background: #000000;
  transition: opacity 0.5s ease;
}

.loader__img{
  width: 548px;
  margin: auto;
}
</style>